import { observable, action } from 'mobx';
export default class SearchSortStore {

  @observable public tabIndex: any;
  @observable public sortFlag: any;

  @action
  setTabIndex(newValue) {
    this.tabIndex = newValue
  }

  @action
  setSortFlag(newValue) {
    this.sortFlag = newValue
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/store/SearchSortStore.ts